export { default } from './CardGeneric';
